import React, { FC } from 'react';

type IconSize = 'sm' | 'md' | 'lg';

interface Props {
  size: IconSize;
}

const InfoIcon: FC<Props> = ({ size }) => {
  const getSize = (size: IconSize) => {
    switch (size) {
      case 'sm':
        return 18;
      case 'lg':
        return 30;
      case 'md':
      default:
        return 22;
    }
  };

  const sizeNumber = getSize(size);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: `${sizeNumber}px`,
        height: `${sizeNumber}px`,
      }}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14.25 16.5H13.5C13.1022 16.5 12.7206 16.342 12.4393 16.0607C12.158 15.7794 12 15.3978 12 15V11.25C12 11.0511 11.921 10.8603 11.7803 10.7197C11.6397 10.579 11.4489 10.5 11.25 10.5H10.5"
        stroke="#232323"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.625 7.5C11.4179 7.5 11.25 7.33211 11.25 7.125C11.25 6.91789 11.4179 6.75 11.625 6.75"
        stroke="#232323"
        strokeWidth="1.2"
      />
      <path
        d="M11.625 7.5C11.8321 7.5 12 7.33211 12 7.125C12 6.91789 11.8321 6.75 11.625 6.75"
        stroke="#232323"
        strokeWidth="1.2"
      />
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        stroke="#232323"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InfoIcon;
